/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2020-12-09 19:44:42
 */

import * as Vue from 'vue-tsx-support';
import { Component, Prop } from 'vue-property-decorator';
import 'vue-tsx-support/enable-check';
import Modal from 'src/types/iview/Modal';
import Button from 'src/types/iview/Button';
import { Toast } from 'src/util/toast';
import { modalFactory } from 'src/util/vueExtend';
import { Integer, IViewDate } from 'src/types/base';
import { Constructor } from 'vue-tsx-support';
import { DeviceControlVOI } from './deviceControl';
import DatePicker from 'src/types/iview/DatePicker';
import { DateTimeUtil, GetMillisecondType } from 'src/util/dateTimeUtil';
import { CommonUtil } from 'src/util/commonUtil';
import DeviceControlApi from './api/deviceControlApi';
import LocalStore from 'src/util/LocalStore';
import { LoginDOI } from 'src/pages/login/loginApi';

export namespace ControlVOI {
    export interface InputItemsI {
        component: Constructor<any>;
        props: any;
        labelWidth?: number;
        field: string;
        label: string;
        realField?: string[];
        dataType?: string
        dealParam?(data): object;
    }
    export interface PropsI {
        mn?: string;
        data?: DeviceControlVOI.RowI;
        polid?: string

        saveSuccess?(): void;

        cancel?(): void;
    }

    export interface FormDataI {
        id?: Integer;
        name: string;
    }
}

@Component
class ControlModal extends Vue.Component<ControlVOI.PropsI> {
    @Prop({
        type: Function,
    })
    cancel!: () => void;

    @Prop({
        type: String,
    })
    mn!: string;

    @Prop({
        type: String,
    })
    polid!: string;

    @Prop({
        type: Object,
    })
    data!: DeviceControlVOI.RowI;


    @Prop({
        type: Function,
    })
    saveSuccess!: () => void;

    visible: boolean = false;

    loading: boolean = false;

    formData: ControlVOI.FormDataI = {
        name: '',
    };

    close() {
        this.cancel && this.cancel();
        this.closeModal();
    }

    closeModal() {
        this.visible = false;
        this.$emit('close', false);
    }

    async save() {
        if((this.data as any).inputItems.length>0) {
            if (!(await this.$validate('formValidate'))) {
                return;
            }
        }
        let userInfo: LoginDOI.LoginResultI = LocalStore.getData('userInfo');
        
        this.loading = true;
        let {code} = await DeviceControlApi.deviceControl(this.data.operateUrl, {
            mn: this.mn,
            polid: this.polid,
            ...this.getQueryObj(),
            user: userInfo.real_name,
            // localip: returnCitySN.cip
            localip: "60.12.0.226"
        })
        this.loading = false;
        if (code === 0) {
            Toast.success('操作成功！');
            this.saveSuccess();
            this.closeModal();
        }
    }
    getNode(h, i: ControlVOI.InputItemsI) {
        let { value, ...props } = i.props;
        return h(i.component, {
            props: { value: i.props.value, ...props },
            on: { input: v => (i.props.value = v) },
        });
    }
    getQueryObj<T>(): T {
        let inputItems:ControlVOI.InputItemsI[]= this.data.inputItems as any
        let o: any = {};
        for (let i = 0, l = inputItems.length; i < l; i++) {
            let item = inputItems[i];
            if(item.dealParam) {
                o = {...o,...item.dealParam(item.props.value)}
                continue
            }
            switch (item.component) {
                case DatePicker:
                    if ((item.props.type || 'daterange').indexOf('range') > -1) {
                        let startType!: GetMillisecondType, endType!: GetMillisecondType;
                        if (item.props.type === 'daterange') {
                            startType = 'start';
                            endType = 'end';
                        } else if (item.props.type === 'monthrange') {
                            startType = 'monthStart';
                            endType = 'monthEnd';
                        }
                        if ((item.props.value as IViewDate[])[0]) {
                            o[item.realField ? item.realField[0] : item.field + 'Start'] = DateTimeUtil.formateDate(DateTimeUtil.getMillisecondFromIviewDate(
                                (item.props.value as IViewDate[])[0],
                                startType,
                            ), 'YYYYMMDDHHmmss');
                        }
                        if ((item.props.value as IViewDate[])[1]) {
                            o[item.realField ? item.realField[1] : item.field + 'End'] = DateTimeUtil.formateDate(DateTimeUtil.getMillisecondFromIviewDate(
                                (item.props.value as IViewDate[])[1],
                                endType,
                            ),'YYYYMMDDHHmmss');
                        }
                    } else {
                        o[item.field] = DateTimeUtil.formateDate(item.props.value as IViewDate,'YYYYMMDDHHmmss');
                    }
                    break;
                default:
                    o[item.field] = item.props.value;
                    break;
            }
        }
        return o;
    }
    getRules(i: ControlVOI.InputItemsI) {
        let rules:any = [
            {required: true, message: i.label+ '必填', trigger: 'blur,change', type: i.dataType||'string'}
        ]
        if(i.component === DatePicker && ~i.props.type.indexOf('range')) {
            rules.push({validator:(rule, value, callback) => {
                if(value.length ===0 || value.some(i=> CommonUtil.isFieldEmpty(i))) {
                    callback(new Error(i.label+ '必填'))
                }else {
                    callback()
                }
            }, trigger: 'blur,change'})
        }
        return rules
    }
    render(h) {
        return (
            <Modal title={this.data.operateName} width="500" v-model={this.visible} mask-closable={false} on-on-cancel={this.close}>
                <i-form v-if={(this.data as any).inputItems.length>0} ref="formValidate" labelWidth={100} model={this.data}  style="width:80%">
                    {(this.data as any).inputItems.map((i,index) => {
                        return (
                            <form-item
                                labelWidth={i.labelWidth}
                                label={i.label}
                                prop={'inputItems.'+index+'.props.value'}
                                rules={
                                    this.getRules(i)
                                }
                            >
                                {this.getNode(h, i)}
                            </form-item>
                        );
                    })}
                </i-form>
                <div style="font-size:14px;text-align:center;" v-else>确定"{this.data.operateName}"操作？</div>
                <div slot="footer">
                    <Button type="primary" ghost on-click={this.close}>
                        取消
                    </Button>
                    <Button type="primary" on-click={this.save} loading={this.loading}>
                        保存
                    </Button>
                </div>
            </Modal>
        );
    }
}

export default function alertControlModal(mn: string, data: DeviceControlVOI.RowI,polid?: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
        modalFactory<ControlVOI.PropsI>(ControlModal)({
            mn,
            data,
            polid,
            saveSuccess() {
                resolve(true);
            },
            cancel() {
                resolve(false);
            },
        });
    });
}
